import { useContext } from 'react'
import { FlexGrid, Tabs } from '@telus-uds/components-web'
import { capitalize } from 'src/blogBuilder/utils/manipulateString'
import { articleConsumer } from 'src/blogBuilder/provider/ArticleProvider'

import { setAnalyticsEvent } from 'src/blogBuilder/analytics/Analytics'
import { ANALYTICS_EVENT_CLICK } from 'src/blogBuilder/utils/constants'

const StoryCategories = () => {
  const { allCategories, changeArticleByCategory, setCount, selectedCategory } = useContext(articleConsumer)
  const setFilterCategoryAnalyticsEvent = (categoryName: string): void => {
    const event = {
      name: `${categoryName} - filter`,
      action: ANALYTICS_EVENT_CLICK,
    }
    setAnalyticsEvent(event)
  }

  const handleOnChangeCategory = (categoryName: string): void => {
    setCount(12)
    setFilterCategoryAnalyticsEvent(categoryName)
    changeArticleByCategory(categoryName)
  }

  const items = allCategories.map((category, index) => {
    return {
      label: capitalize(category.name),
      id: capitalize(category.name),
      selected: category.name.toLowerCase() === selectedCategory.toLowerCase(),
      onPress: () => handleOnChangeCategory(category.name),
      testID: `navbar-tab-${index}${category.name === selectedCategory ? '-selected' : ''}`,
    }
  })

  return (
    <FlexGrid>
      <FlexGrid.Row horizontalAlign="start" verticalAlign="middle">
        <FlexGrid.Col testID="navbar-with-tabs">
          <Tabs
            items={items}
            itemTokens={{
              maxWidth: 'none',
            }}
          />
        </FlexGrid.Col>
      </FlexGrid.Row>
    </FlexGrid>
  )
}

export default StoryCategories
